import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import useCausticsMaterial from '../shaders/caustics/CausticsMaterial';
import * as THREE from 'three';

const BackgroundCaustics = () => {
  const meshRef = useRef();
  const material = useCausticsMaterial();
  
  // Single animation frame handler for better performance
  useFrame((state) => {
    if (material && material.uniforms) {
      material.uniforms.uTime.value = state.clock.getElapsedTime();
    }
    
    if (meshRef.current) {
      // Very subtle rotation to add some dynamism
      meshRef.current.rotation.z = Math.sin(state.clock.getElapsedTime() * 0.05) * 0.02;
    }
  });

  return (
    <mesh 
      ref={meshRef}
      position={[0, 0, -25]}
      rotation={[0, 0, 0]}
      scale={[50, 120, 1]} 
      frustumCulled={false} // Disable frustum culling to ensure it's always rendered
      visible={true} // Explicitly set visibility
    >
      <planeGeometry args={[1, 1]} />
      <primitive object={material} attach="material" />
    </mesh>
  );
};

export default BackgroundCaustics;
